<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on }">
      <span :aria-label="title ? `${title}: ${name}` : name" :style="{ width: `${size}px`, height: `${size}px`, fontSize: `${Math.round(size * 0.4)}px` }"
            class="initials" role="img" v-on="on">{{ initials }}</span>
    </template>
    <span>{{ title ? `${title}: ${name}` : name }}</span>
  </v-tooltip>
</template>

<script lang="ts">
import Vue from 'vue';

/** Initials instead of a profile picture, so the person is recognisable without hovering; full name as tooltip */
export default Vue.extend({
  props: {
    name: {type: String, required: true},
    title: {type: String, default: ''},
    size: {type: Number, default: 28},
  },
  computed: {
    initials(): string {
      const parts = this.name.trim().split(/\s+/).filter(Boolean);
      if (!parts.length) {
        return '?';
      }
      const first = parts[0][0] || '';
      const last = parts.length > 1 ? parts[parts.length - 1][0] : '';
      return `${first}${last}`.toUpperCase();
    },
  },
});
</script>

<style scoped>
.initials {
  display: inline-grid;
  place-items: center;
  flex: none;
  border-radius: 9px;
  font-weight: 700;
  letter-spacing: .02em;
  background: #E8F1FD;
  color: #0D47A1;
}

.theme--dark .initials {
  background: rgba(144, 202, 249, .16);
  color: #90CAF9;
}
</style>
